import { baseRoute } from '../../constants/routes';

export const LOGIN_ROUTE = baseRoute + '/oauth/token';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';